// src/components/JsonLdPortal.tsx
'use client'

import { useLayoutEffect } from 'react'

type Props = { schema: object }

export default function JsonLdPortal({ schema }: Props) {
  useLayoutEffect(() => {
    const script = document.createElement('script')
    script.type = 'application/ld+json'
    script.text = JSON.stringify(schema)
    document.head.appendChild(script)
    return () => {
      document.head.removeChild(script)
    }
  }, [schema])

  return null
}
